import { request, post } from '@/plugins/requestU';

//根据typeKey查询item
export function listDict(data) {
    return post('/maindata/v0.1/maindata/maindata/type/listDict', data);
}
